function init_idb(event){
  var db = {}
  // alert(`${event.oldVersion}`)
  db.result = event.target.result;

  // console.log({event});
  // console.log(event.target);

  // ! SOLUTION
  if (!Array.from(db.result.objectStoreNames).includes('solutions')){
    console.log('do not have solution');
    // alert('do not have solution')
    db.solution_store = db.result.createObjectStore('solutions', { keyPath: "id", autoIncrement: true });
    console.log('created solution');
    // alert('Soluções salvas para uso offline')
  } else {
    console.log('have solution');
    // alert('Soluções já preparadas para uso offline')
    db.solution_tx = event.target.transaction
    db.solution_store = db.solution_tx.objectStore('solutions');
  }
  if (!db.solution_store.indexNames.contains("id")) {
    db.solution_store.createIndex('id', 'id', { unique: true }); 
    console.log('created solution id index');
    // alert('created solution id index')
  }

  // ! DONE-FORM
  if (!Array.from(db.result.objectStoreNames).includes('done_forms')){
    console.log('do not have done-forms');
    // alert('do not have done-forms')
    // db.done_form_store = db.result.createObjectStore("solutions", { keyPath: "id", autoIncrement: true });
    db.done_form_store = db.result.createObjectStore('done_forms', { keyPath: "done_at" });
    console.log('created done-forms');
    // alert('Execuções preparadas para uso offline')
    // db.store = db.result.createObjectStore("custom_fields", { keyPath: "id" });
  } else {
    console.log('have done-forms');
    // alert('Execuções já estavam preparadas para uso offline')
    db.done_form_tx = event.target.transaction
    db.done_form_store = db.done_form_tx.objectStore('done_forms');
  }
  if (!db.done_form_store.indexNames.contains("done_at")) {
    db.done_form_store.createIndex('done_at', 'done_at', { unique: false });
    console.log('created done-form done-at index');
    // alert('created done-form done-at index')
  }


  // ! CUSTOM-FIELD
  if (!Array.from(db.result.objectStoreNames).includes('custom_fields')){
    console.log('do not have custom_fields');
    // alert('do not have custom_fields')
    db.custom_field_store = db.result.createObjectStore('custom_fields', { keyPath: "id"});
    // db.store = db.result.createObjectStore("solutions", { keyPath: "id", autoIncrement: true });
    console.log('created custom_fields');
    // alert('Campos personalizados preparados para uso offline')
    // alert('created custom_fields')
    // db.store = db.result.createObjectStore("done_forms", { keyPath: "done_at" });
  } else {
    console.log('have custom_fields');
    // alert('Campos personalizados já estavam preparados para uso offline')
    // alert('have custom_fields')
    db.cutom_field_tx = event.target.transaction
    db.custom_field_store = db.cutom_field_tx.objectStore('custom_fields');
  }
  if (!db.custom_field_store.indexNames.contains("id")) {
    db.custom_field_store.createIndex('id', 'id', { unique: true });
  }
  if (!db.custom_field_store.indexNames.contains("name")) {
    db.custom_field_store.createIndex('name', 'name', { unique: false });
  }
  if (!db.custom_field_store.indexNames.contains("main_field")) {
    db.custom_field_store.createIndex('main_field', 'main_field', { unique: false }); 
  } 


  // ! DONE-ITEMS
  if (!Array.from(db.result.objectStoreNames).includes('done_items')){
    console.log('do not have done_items');
    // alert('do not have done_items')
    db.custom_field_store = db.result.createObjectStore('done_items', { keyPath: "idb_id"});
    // db.store = db.result.createObjectStore("solutions", { keyPath: "id", autoIncrement: true });
    console.log('created done_items');
    // alert('Campos personalizados preparados para uso offline')
    // alert('created done_items')
    // db.store = db.result.createObjectStore("done_forms", { keyPath: "done_at" });
  } else {
    console.log('have done_items');
    // alert('Campos personalizados já estavam preparados para uso offline')
    // alert('have done_items')
    db.cutom_field_tx = event.target.transaction
    db.custom_field_store = db.cutom_field_tx.objectStore('done_items');
  }
  if (!db.custom_field_store.indexNames.contains("id")) {
    db.custom_field_store.createIndex('id', 'id', { unique: true });
  }
  if (!db.custom_field_store.indexNames.contains("idb_id")) {
    db.custom_field_store.createIndex('idb_id', 'idb_id', { unique: true });
  }
  if (!db.custom_field_store.indexNames.contains("done_form_id")) {
    db.custom_field_store.createIndex('done_form_id', 'done_form_id', { unique: false });
  }
  if (!db.custom_field_store.indexNames.contains("execution_idb_id")) {
    db.custom_field_store.createIndex('execution_idb_id', 'execution_idb_id', { unique: false });
  }
  if (!db.custom_field_store.indexNames.contains("title")) {
    db.custom_field_store.createIndex('title', 'title', { unique: false });
  }
  if (!db.custom_field_store.indexNames.contains("sentence")) {
    db.custom_field_store.createIndex('sentence', 'sentence', { unique: false }); 
  } 
  if (!db.custom_field_store.indexNames.contains("answer")) {
    db.custom_field_store.createIndex('answer', 'answer', { unique: false }); 
  } 


  // ! EXECUTIONS
  if (!Array.from(db.result.objectStoreNames).includes('executions')){
    console.log('do not have executions');
    // alert('do not have executions')
    db.custom_field_store = db.result.createObjectStore('executions', { keyPath: "idb_id"});
    // db.store = db.result.createObjectStore("solutions", { keyPath: "id", autoIncrement: true });
    console.log('created executions');
    // alert('Campos personalizados preparados para uso offline')
    // alert('created executions')
    // db.store = db.result.createObjectStore("done_forms", { keyPath: "done_at" });
  } else {
    console.log('have executions');
    // alert('Campos personalizados já estavam preparados para uso offline')
    // alert('have executions')
    db.cutom_field_tx = event.target.transaction
    db.custom_field_store = db.cutom_field_tx.objectStore('executions');
  }
  if (!db.custom_field_store.indexNames.contains("id")) {
    db.custom_field_store.createIndex('id', 'id', { unique: true });
  }
  if (!db.custom_field_store.indexNames.contains("idb_id")) {
    db.custom_field_store.createIndex('idb_id', 'idb_id', { unique: true });
  }
  if (!db.custom_field_store.indexNames.contains("title")) {
    db.custom_field_store.createIndex('title', 'title', { unique: false });
  }
  if (!db.custom_field_store.indexNames.contains("name")) {
    db.custom_field_store.createIndex('name', 'name', { unique: false }); 
  }
  if (!db.custom_field_store.indexNames.contains("solution_id")) {
    db.custom_field_store.createIndex('solution_id', 'solution_id', { unique: false }); 
  }
  if (!db.custom_field_store.indexNames.contains("user_id")) {
    db.custom_field_store.createIndex('user_id', 'user_id', { unique: false }); 
  }


  // ! USERS
  if (!Array.from(db.result.objectStoreNames).includes('users')){
    console.log('do not have users');
    // alert('do not have users')
    db.user_store = db.result.createObjectStore('users', { keyPath: "id"});
    // db.store = db.result.createObjectStore("solutions", { keyPath: "id", autoIncrement: true });
    console.log('created users');
    // alert('Campos personalizados preparados para uso offline')
    // alert('created users')
    // db.store = db.result.createObjectStore("done_forms", { keyPath: "done_at" });
  } else {
    console.log('have users');
    // alert('Campos personalizados já estavam preparados para uso offline')
    // alert('have users')
    db.cutom_field_tx = event.target.transaction
    db.user_store = db.cutom_field_tx.objectStore('users');
  }
  if (!db.user_store.indexNames.contains("id")) {
    db.user_store.createIndex('id', 'id', { unique: true });
  }
  if (!db.user_store.indexNames.contains("name")) {
    db.user_store.createIndex('name', 'name', { unique: false });
  }
  if (!db.user_store.indexNames.contains("employee_id")) {
    db.user_store.createIndex('employee_id', 'employee_id', { unique: false }); 
  } 
  if (!db.user_store.indexNames.contains("company_id")) {
    db.user_store.createIndex('company_id', 'company_id', { unique: false }); 
  } 
}

export default init_idb
